import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { NgbDateParserFormatter, NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { AppComponent } from "./app.component";
import { appRouting } from "./app.routes";
import { NgbDateFRParserFormatter } from "./core/component/date-formatter/custom-date-formater";
import { PageModule } from "./pages/pages.module";
//import { Angulartics2Module } from 'angulartics2';
import { SharedModule } from "./shared/shared.module";

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    HttpClientModule,
    NgbModule,
    appRouting,
    SharedModule,
    PageModule,
  ],
  providers: [
    {
      provide: NgbDateParserFormatter,
      useFactory: () => new NgbDateFRParserFormatter("shortDate"),
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
